import { render, staticRenderFns } from "./cModalSector.vue?vue&type=template&id=61fbc1a3"
import script from "./cModalSector.vue?vue&type=script&lang=js"
export * from "./cModalSector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports